import { __extends } from "tslib";
import * as React from 'react';
import { Icon, DeprecatedLinkButton } from '../../../primitives';
import { DeprecatedText } from '../../../deprecated-typography';
import { image } from '../../../icons';
import * as classNames from 'classnames';
import { FileUploadError } from '../../../common';
export var fileUploaderKey = 'file-uploader';
var isWithProgress = function (uploadFunction) { return uploadFunction.length === 2; };
export var UploadErrorType;
(function (UploadErrorType) {
    UploadErrorType["MAX_SIZE"] = "max-size";
    UploadErrorType["FILE_TYPE"] = "file-type";
    UploadErrorType["UNEXPECTED_ERROR"] = "unexpected-error";
})(UploadErrorType || (UploadErrorType = {}));
var FileUploader = /** @class */ (function (_super) {
    __extends(FileUploader, _super);
    function FileUploader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            uploadPercentage: 0,
            fileName: '',
            uploadError: ''
        };
        _this.tp = function (key, params) { return _this.props.t("common.image-uploader." + key, params); };
        _this.onFileSelect = function (file) {
            var isSvgFile = file.type.includes('svg');
            var maybeCleanName = isSvgFile ? file.name.replace(/[()]/g, '') : file.name;
            var selectedFile = isSvgFile ? new File([file], maybeCleanName, { type: file.type }) : file;
            _this.setState({ fileName: maybeCleanName });
            _this.props.fileUploader.uploadFile({ file: selectedFile }, _this.progressListener).then(_this.handleUploadSuccess)
                .catch(_this.handleUploadError);
        };
        _this.handleUploadByUrl = function (imageUrl) {
            var uploadImageFromUrl = _this.props.fileUploader.uploadImageFromUrl;
            if (isWithProgress(uploadImageFromUrl)) {
                var uploadWithProgress = uploadImageFromUrl;
                uploadWithProgress({ url: imageUrl }, _this.progressListener)
                    .then(_this.handleUploadSuccess);
            }
            else {
                var dummyProgress = function () {
                    var magicNumber = 10;
                    var percent = _this.state.uploadPercentage;
                    _this.setState({ uploadPercentage: Math.round(percent + magicNumber * (1 - percent / 100)) });
                };
                var intervalLength = 100;
                var interval_1 = setInterval(dummyProgress, intervalLength);
                uploadImageFromUrl({ url: imageUrl })
                    .then(function (res) {
                    clearInterval(interval_1);
                    _this.handleUploadSuccess(res);
                })
                    .catch(function (e) {
                    clearInterval(interval_1);
                    _this.handleUploadError(e);
                });
            }
        };
        _this.progressListener = function (progress) {
            var uploadPercentage = progress.total ? Math.round((progress.loaded / progress.total) * 100) : 0;
            _this.setState({ uploadPercentage: uploadPercentage });
        };
        _this.handleUploadSuccess = function (res) {
            var uploadError = res.fileSizeBytes > _this.props.fileUploader.uploadLimitInBytes ? UploadErrorType.MAX_SIZE
                : _this.props.fileUploader.supportedFileTypes.indexOf("." + res.extension) === -1 ? UploadErrorType.FILE_TYPE : '';
            if (uploadError) {
                _this.setState({ uploadError: uploadError, uploadPercentage: 0, fileName: '' });
                _this.props.onError();
            }
            else {
                _this.props.onChange(res.filelink);
            }
        };
        _this.handleUploadError = function (e) {
            var errorCode = (e.response && e.response.data) ? e.response.data.errorCode : null;
            var uploadError = errorCode === FileUploadError.MAX_FILE_SIZE_EXCEEDED ? UploadErrorType.MAX_SIZE :
                errorCode === FileUploadError.INVALID_EXTENSION ? UploadErrorType.FILE_TYPE : UploadErrorType.UNEXPECTED_ERROR;
            _this.setState({ uploadPercentage: 0, fileName: '', uploadError: uploadError });
            _this.props.onError();
        };
        _this.renderErrorState = function () {
            var props = _this.props;
            var maxSizeInMB = Math.round(_this.props.fileUploader.uploadLimitInBytes / Math.pow(10, 6));
            var errorDescriptionText = _this.tp("error." + _this.state.uploadError + ".description", { supportedTypes: _this.props.fileUploader.supportedFileTypes.join(', '), maxSize: maxSizeInMB });
            var maybeClickTryAgain = props.onClickTryAgain ?
                React.createElement(DeprecatedLinkButton, { onClick: props.onClickTryAgain }, _this.tp('try-again')) : null;
            var errorMsg = props.customErrorMsg === undefined ? (React.createElement("div", { className: 'error-state' },
                React.createElement("div", { className: 'error-text-wrapper' },
                    React.createElement("div", { className: 'error-title' }, _this.tp("error." + _this.state.uploadError)),
                    React.createElement("div", { className: 'error-description' }, errorDescriptionText)),
                maybeClickTryAgain)) : (React.createElement("div", { className: 'error-state' }, props.customErrorMsg(_this.state.uploadError)));
            return errorMsg;
        };
        return _this;
    }
    FileUploader.prototype.componentDidMount = function () {
        var fileToUpload = this.props.fileToUpload;
        if (typeof fileToUpload === 'string') {
            this.handleUploadByUrl(fileToUpload);
        }
        else {
            this.onFileSelect(fileToUpload);
        }
    };
    FileUploader.prototype.render = function () {
        var uploadingState = (React.createElement("div", { className: 'uploading-state-container' },
            React.createElement("div", { className: 'uploading-text-container' },
                React.createElement("span", { className: 'filename-wrapper' },
                    React.createElement(DeprecatedText, { type: 't1a' },
                        React.createElement(Icon, { icon: image }),
                        this.state.fileName)),
                React.createElement("div", { className: 'uploading-text-wrapper' },
                    React.createElement("span", { className: 'uploading-text' }, this.tp('uploading')),
                    React.createElement("span", { className: 'progress-percentage' }, this.state.uploadPercentage + "%"))),
            React.createElement("div", { className: 'upload-progress-bar', style: { width: this.state.uploadPercentage + "%" } })));
        var size = this.props.size;
        var classnames = classNames(fileUploaderKey, {
            short: size && size.height === 'short',
            narrow: size && size.width === 'narrow',
            xnarrow: size && size.width === 'xnarrow'
        });
        return (React.createElement("div", { className: classnames }, this.state.uploadError ? this.renderErrorState() : uploadingState));
    };
    return FileUploader;
}(React.PureComponent));
export { FileUploader };
//# sourceMappingURL=index.js.map